import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";

import Button from "components/Button";
import { ContentArea, FormRow, Title } from "components/LayoutParts";
import { useFindOwnerEntity } from "pages/PitPort/OwnerEntity/api";

import { PIT_PORT_OWNER_ENTITY_TYPE_LABEL } from "../OwnerEntity/constants";

const OwnerEntityTitleArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0px 0 10px 0;
  align-items: center;
  width: 100%;
`;

const Label = styled.div`
  min-width: 120px;
  margin: 2px 5px;
`;
const ItemWrap = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding-left: 40px;
`;

const ContentWrap = styled.div`
  flex: 1;
`;

const InnerItem = styled.div``;

/**
 * 貸主詳細画面
 */
const OwnerEntityDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { data } = useFindOwnerEntity({ ownerEntityId: params.id as string });
  return (
    <>
      <OwnerEntityTitleArea>
        <Title>貸主情報</Title>
        <Button
          type="secondary"
          onClick={() => navigate(`/pit_port/owner-entities/${params.id}/edit`)}
          label="貸主情報を編集"
          width="160px"
        />
      </OwnerEntityTitleArea>
      <ContentWrap>
        <ContentArea>
          <FormRow>
            <Label>貸主名</Label>
            <ItemWrap>
              <InnerItem>{data?.data.name}</InnerItem>
            </ItemWrap>
          </FormRow>
          <FormRow>
            <Label>住所</Label>
            <ItemWrap>
              <InnerItem>{data?.data.address}</InnerItem>
            </ItemWrap>
          </FormRow>
          <FormRow>
            <Label>電話番号</Label>
            <ItemWrap>
              <InnerItem>{data?.data.tel}</InnerItem>
            </ItemWrap>
          </FormRow>
          <FormRow>
            <Label>メールアドレス</Label>
            <ItemWrap>
              <InnerItem>{data?.data.email}</InnerItem>
            </ItemWrap>
          </FormRow>
          <FormRow>
            <Label>種類</Label>
            <ItemWrap>
              <InnerItem>{PIT_PORT_OWNER_ENTITY_TYPE_LABEL[data?.data.type]}</InnerItem>
            </ItemWrap>
          </FormRow>
          <FormRow>
            <Label>利益配分率</Label>
            <ItemWrap>
              <InnerItem>{data?.data.profitShareRate * 100}%</InnerItem>
            </ItemWrap>
          </FormRow>
        </ContentArea>
      </ContentWrap>
    </>
  );
};

export default OwnerEntityDetail;
